import {Component, ElementRef, OnInit, TemplateRef, VERSION, ViewChild} from '@angular/core';
import {ZXingScannerComponent} from '@zxing/ngx-scanner';
import { Result } from '@zxing/library';
import {AuthService} from '../services/auth.service';
import {AngularFireDatabase} from 'angularfire2/database';
import {Observable} from 'rxjs';
import {FamilyService} from '../services/family.service';
import {environment} from '../../environments/environment';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {ModalDirective, TypeaheadMatch} from 'ngx-bootstrap';
import {FormControl, FormGroup, NgControl} from '@angular/forms';



@Component({
  selector: 'app-scanner',
  templateUrl: './scanner.component.html',
  styleUrls: ['./scanner.component.scss']
})
export class ScannerComponent implements OnInit {

  public formSearch: FormGroup;

  ngVersion = VERSION.full;

  @ViewChild('scanner')
  scanner: ZXingScannerComponent;
  items: Observable<any[]>;
  list: Observable<any[]>;
  @ViewChild(ModalDirective) modal: ModalDirective;
  @ViewChild('inputSearcher')
  inputSearcher: ElementRef;
  @ViewChild(ModalDirective) noConnection: ModalDirective;


  disabled: boolean;
  calculated: boolean;
  hasDevices: boolean;
  surname: string;
  familiaSelected: string;
  hasPermission: boolean;
  lostConection = false;
  qrResultString: string;
  qrResult: Result;
  existFamily = false;
  family: Observable<any>;
  children: any[];
  keyRetirado: any;
  public listUsers: Array<any> = [];
  public listUsersFounded: Array<any> = [];

  availableDevices: MediaDeviceInfo[];
  currentDevice: MediaDeviceInfo;

  constructor(public db: AngularFireDatabase, private familyService: FamilyService, private modalService: BsModalService) {
    this.formSearch = new FormGroup({
      'searcher': new FormControl('')
    });
  }


  ngOnInit(): void {
    if (this.scanner && this.scanner.camerasFound) {
      this.scanner.camerasFound.subscribe((devices: MediaDeviceInfo[]) => {
        this.hasDevices = true;
        this.availableDevices = devices;
      });
      this.scanner.camerasNotFound.subscribe(() => this.hasDevices = false);
      this.scanner.scanComplete.subscribe((result: Result) => this.qrResult = result);
      this.scanner.permissionResponse.subscribe((perm: boolean) => this.hasPermission = perm);
      this.allFamilies();
    }
  }

  displayCameras(cameras: MediaDeviceInfo[]) {
    this.availableDevices = cameras;

  }

  handleQrCodeResult(resultString: string) {
    this.qrResultString = resultString;
    this.lostConection = false;
    this.modal.show();
    this.familyService.findChildren(this.qrResultString).subscribe(
      (children) => {
        this.children = children;
        this.surname = this.children[0].nombre.split(',')[0];
        this.familiaSelected = this.qrResultString;
        this.children.forEach((child, index) => {
          this.isDisabled(index, child.retirado);
          child.checked = true;
        });
      }
    );
  }

  onDeviceSelectChange(selectedValue: string) {
    this.currentDevice = this.scanner.getDeviceById(selectedValue);
  }

  stateToEmoji(state: boolean): string {

    const states = {
      // not checked
      undefined: '❔',
      // failed to check
      null: '⭕',
      // success
      true: '✔',
      // can't touch that
      false: '❌'
    };

    return states['' + state];
  }
  callAlumnoByGroup(children) {
    this.lostConection = false;
    const conecSubs$ = this.db.object('.info/connected').valueChanges().subscribe(
      connected => {
        if (connected) {
          children.forEach(child => {
            console.log('Child tildado OK', child)
            if (child.checked && !child.isDisabled) {
              this.callAlumno(child.key, child.grado, child.nombre);
            }
          });
          this.modal.hide();
        } else {
          this.lostConection = true;
          setTimeout(() => {
            this.lostConection = false;
          }, 2000);
        }
        conecSubs$.unsubscribe()
      }
    );
  }


  callAlumno(key, grado, nombre){
   this.familyService.confirmRetirado(key, grado, nombre, this.familiaSelected);
 }

  searchFamily(ev: any): void {
    const value = ev['target']['value'];
    this.listUsersFounded = this.listUsers.filter(word => (word.nombre).toLowerCase().indexOf(value.toLowerCase()) > -1);
  }

  allFamilies(): void {
    this.familyService.findAlumnos().subscribe(snapshots => {
      this.listUsers = snapshots;
    });
  }

  public onSelectedUser(ev: TypeaheadMatch): void {
    this.lostConection = false;

    this.inputSearcher.nativeElement.value = '';
    const conecSubs$ = this.db.object('.info/connected').valueChanges().subscribe(
      connected => {
        if (connected) {
          this.familyService.findChildren(ev.item.familia).subscribe(
            (children) => {
              this.children = children;
              this.surname = this.children[0].nombre.split(',')[0];
              this.familiaSelected = ev.item.familia;
              this.children.forEach((child, index) => {
                this.isDisabled(index, child.retirado);
                child.checked = true;
              });
            }
          );
        }
        this.modal.show();
        conecSubs$.unsubscribe();
      });
  }

  checkAlumno(index) {
    this.children.forEach((child, index2) => {
      if(index === index2) {
        child.checked = !child.checked;
      }
    });
  }

  resetAlumno(nombre, key, grado) {
    this.lostConection = false;
    const conecSubs$ = this.db.object('.info/connected').valueChanges().subscribe(
      connected => {
        if (connected) {
          this.familyService.removeFromGradoAndAll(nombre, grado);
          this.familyService.resetStateInFamily(this.familiaSelected, key);
        } else {
          this.lostConection = true;
          setTimeout(() => {
            this.lostConection = false;
          }, 2000);
        }
        conecSubs$.unsubscribe();
      });
  }

  public isDisabled(index2, key: string): void {
    this.familyService.isDisabled(key).subscribe(
      resp => {
        this.children.forEach((item, index) => {
          if (index === index2) {
            item.isDisabled = resp && resp.retirado ? resp.retirado : false;
          }
        });
      }
    );

  }
}
